import { call, put } from "redux-saga/effects";
import { API_URLS, COUNTRY_DETAILS_TO_SELECT } from "../../../config";
import { CallApi } from "./api/callApi";
import { createdAquirer, createdBusinessDescription, createdBusinessType, createdTerminalType, getCountrySuccess, stopLoading, storeAddress, storeAquirer, storeBusinessDescription, storeBusinessType, storeFinalAddress, storeTerminalModel, storeTerminalType } from "../../redux/slices/commonDropdownSlice";

export function* countryDropdownSaga(action) {
    try {
        const data = { fields: COUNTRY_DETAILS_TO_SELECT };
        // //console.log(data)
        const resp = yield call(CallApi.GET, API_URLS.EXTERNAL.COUNTRY, data, null);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data) {
            // //console.log(resp);
            yield put(getCountrySuccess(resp.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(stopLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(stopLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* addressLookupSaga(action) {
    try {
        const data = action.payload
        // const resp = {
        //     data: {
        //         Items: [
        //             {
        //                 "Id": "in-lp|e_ERxosBX8V_g8REuoCQ",
        //                 "Type": "Container",
        //                 "Text": "India Colony Road Ahmedabad",
        //                 "Highlight": "0-5",
        //                 "Description": " - 91 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|k_ERxosBX8V_g8REuoCQ",
        //                 "Type": "Container",
        //                 "Text": "India Colony Bus Station Road Ahmedabad 380024",
        //                 "Highlight": "0-5",
        //                 "Description": " - 36 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|W_ESxosBX8V_g8REhfkb",
        //                 "Type": "Container",
        //                 "Text": "India Gardens Road Thiruvananthapuram 695009",
        //                 "Highlight": "0-5",
        //                 "Description": " - 2 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|5_ISxosBX8V_g8REkQWz",
        //                 "Type": "Container",
        //                 "Text": "Indian Oil Corporation Ltd Road Navi Mumbai",
        //                 "Highlight": "0-5",
        //                 "Description": " - 4 Addresses"
        //             },
        //             {
        //                 "Id": "IN|LP|B|43098846|_ENG",
        //                 "Type": "Address",
        //                 "Text": "India Engineering Works Coimbatore 641018",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             },
        //             {
        //                 "Id": "IN|LP|B|43098970|_ENG",
        //                 "Type": "Address",
        //                 "Text": "Indian Bakery Coffee Shop Addis Street Coimbatore 641018",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             },
        //             {
        //                 "Id": "IN|LP|B|166|_ENG",
        //                 "Type": "Address",
        //                 "Text": "Indian Airlines SH 10 Bambooflat 744107",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             },
        //             {
        //                 "Id": "in-lp|e_ERxosBX8V_g8REuoCQ",
        //                 "Type": "Container",
        //                 "Text": "India Colony Road Ahmedabad",
        //                 "Highlight": "0-5",
        //                 "Description": " - 91 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|k_ERxosBX8V_g8REuoCQ",
        //                 "Type": "Container",
        //                 "Text": "India Colony Bus Station Road Ahmedabad 380024",
        //                 "Highlight": "0-5",
        //                 "Description": " - 36 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|W_ESxosBX8V_g8REhfkb",
        //                 "Type": "Container",
        //                 "Text": "India Gardens Road Thiruvananthapuram 695009",
        //                 "Highlight": "0-5",
        //                 "Description": " - 2 Addresses"
        //             },
        //             {
        //                 "Id": "in-lp|5_ISxosBX8V_g8REkQWz",
        //                 "Type": "Container",
        //                 "Text": "Indian Oil Corporation Ltd Road Navi Mumbai",
        //                 "Highlight": "0-5",
        //                 "Description": " - 4 Addresses"
        //             },
        //             {
        //                 "Id": "IN|LP|B|43098846|_ENG",
        //                 "Type": "Address",
        //                 "Text": "India Engineering Works Coimbatore 641018",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             },
        //             {
        //                 "Id": "IN|LP|B|43098970|_ENG",
        //                 "Type": "Address",
        //                 "Text": "Indian Bakery Coffee Shop Addis Street Coimbatore 641018",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             },
        //             {
        //                 "Id": "IN|LP|B|166|_ENG",
        //                 "Type": "Address",
        //                 "Text": "Indian Airlines SH 10 Bambooflat 744107",
        //                 "Highlight": "0-5",
        //                 "Description": ""
        //             }
        //         ],
        //     },
        //     status: 200,
        // }
        const resp = yield call(CallApi.GET, API_URLS.EXTERNAL.ADDRESS_LOOKUP, data?.data, null);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data) {
            // //console.log(resp);
            yield put(storeAddress(resp?.data?.Items))
            action && action.callbackSuccess && action.callbackSuccess({ data: resp.data });
        } else {
            yield put(stopLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(stopLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getAddressSaga(action) {
    try {
        const data = action.payload
        // const resp = {
        //     data: {
        //         Items: [
        //             {
        //                 "id": "GB|RM|A|4624695|A3",
        //                 "domesticId": "4624695",
        //                 "language": "ENG",
        //                 "languageAlternatives": "",
        //                 "department": null,
        //                 "company": "GBG plc",
        //                 "subBuilding": "",
        //                 "buildingNumber": "",
        //                 "buildingName": "The Foundation",
        //                 "secondaryStreet": "",
        //                 "street": "Herons Way",
        //                 "block": null,
        //                 "neighbourhood": null,
        //                 "district": "Chester Business Park",
        //                 "city": "Chester",
        //                 "line1": "The Foundation",
        //                 "line2": "Herons Way",
        //                 "line3": "Chester Business Park",
        //                 "line4": "",
        //                 "line5": "",
        //                 "adminAreaName": "Cheshire West and Chester",
        //                 "adminAreaCode": null,
        //                 "province": "Cheshire",
        //                 "provinceName": "Cheshire",
        //                 "provinceCode": null,
        //                 "postalCode": "CH4 9GB",
        //                 "countryName": "United Kingdom",
        //                 "countryIso2": "GB",
        //                 "countryIso3": "GBR",
        //                 "countryIsoNumber": "826",
        //                 "sortingNumber1": "30213",
        //                 "sortingNumber2": null,
        //                 "barcode": "(CH49GB1AR)",
        //                 "poBoxNumber": null,
        //                 "label": "Phonelink plcThe FoundationHerons WayChester Business ParkCHESTERCH4 9GBUNITED KINGDOM",
        //                 "type": 1,
        //                 "dataLevel": 0,
        //                 "source": "P"
        //             },
        //             {
        //                 "id": "GB|RM|A|4624695|A3",
        //                 "domesticId": "4624695",
        //                 "language": "CYM",
        //                 "languageAlternatives": "",
        //                 "department": null,
        //                 "company": "GBG plc",
        //                 "subBuilding": "",
        //                 "buildingNumber": "",
        //                 "buildingName": "The Foundation",
        //                 "secondaryStreet": "",
        //                 "street": "Herons Way",
        //                 "block": null,
        //                 "neighbourhood": null,
        //                 "district": "Chester Business Park",
        //                 "city": "Caer",
        //                 "line1": "The Foundation",
        //                 "line2": "Herons Way",
        //                 "line3": "Chester Business Park",
        //                 "line4": "",
        //                 "line5": "",
        //                 "adminAreaName": "Cheshire West and Chester",
        //                 "adminAreaCode": null,
        //                 "province": "Cheshire",
        //                 "provinceName": "Cheshire",
        //                 "provinceCode": null,
        //                 "postalCode": "CH4 9GB",
        //                 "countryName": "United Kingdom",
        //                 "countryIso2": "GB",
        //                 "countryIso3": "GBR",
        //                 "countryIsoNumber": "826",
        //                 "sortingNumber1": "30213",
        //                 "sortingNumber2": null,
        //                 "barcode": "(CH49GB1AR)",
        //                 "poBoxNumber": null,
        //                 "label": "Phonelink plcThe FoundationHerons WayChester Business ParkCAERCH4 9GBUNITED KINGDOM",
        //                 "type": 1,
        //                 "dataLevel": 0,
        //                 "source": "W"
        //             }
        //         ]
        //     },
        //     status: 200,
        // }
        const resp = yield call(CallApi.GET, API_URLS.EXTERNAL.GET_ADDRESS_DATA, data?.data, null);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data) {
            // //console.log(resp);
            yield put(storeFinalAddress(resp?.data?.Items))
            action && action.callbackSuccess && action.callbackSuccess({ data: resp?.data });
        } else {
            yield put(stopLoading())
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        yield put(stopLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* businessDescriptionSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.DROPDOWN.BUSINESS_DESCRIPTION, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createdBusinessDescription(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* listDescriptionSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.DROPDOWN.BUSINESS_DESCRIPTION, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeBusinessDescription(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}






export function* businessTypeSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.DROPDOWN.BUSINESS_TYPE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createdBusinessType(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        // //console.log(e);
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* listTypeSaga(action) {
    try {
        const data = action.payload;
        // //console.log(data);
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.DROPDOWN.BUSINESS_TYPE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeBusinessType(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        // //console.log(e);
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


// Aquirer Saga 

export function* addAquirerSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.DROPDOWN.AQUIRER, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createdAquirer(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* getAquirerSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.DROPDOWN.AQUIRER, data?.data, data?.token)
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeAquirer(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        // //console.log(e);
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


// Terminal Type Saga
export function* addTerminalTypeSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.DROPDOWN.TERMINAL_TYPE, data?.data, data?.token)
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createdTerminalType(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* getTerminalTypeSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.DROPDOWN.TERMINAL_TYPE, data?.data, data?.token)
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTerminalType(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        // //console.log(e);
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



// Terminal Model saga
export function* addTerminalModelSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.DROPDOWN.TERMINAL_MODEL, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(createdTerminalModel(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* getTerminalModelSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.DROPDOWN.TERMINAL_MODEL, data?.data, data?.token)
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTerminalModel(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        // //console.log(e);
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}